<template>
  <ButtonComponent
    id="request_microsoft_login"
      :variant="$props.variant"
      :text="buttonText[$props.type][$props.lang]"
      :image="'https://cdn.systemico.net/abc/icons/microsoft.svg'"
      @click="loginWithGoogle()"
      class="text-center"
  >
  </ButtonComponent>
</template>
<script>
import ButtonComponent from './ButtonComponent.vue'
export default {
  name: 'ButtonMicrosoftLogin',
  components: {
    ButtonComponent
  },
  props: {
    variant: String,
    lang: {
      type: String,
      default: 'EN'
    },
    type: {
      type: String,
      default: 'LOGIN'
    }
  },
  data () {
    return {
      buttonText: {
        LOGIN: {
          EN: 'Sign in <b>with Microsoft</b>',
          ES: 'Iniciar <b>con Microsoft</b>',
          PT: 'Entrar <b>com a Microsoft</b>',
          FR: 'Se connecter <b>avec Microsoft</b>'
        },
        SIGNUP: {
          EN: 'Sign up <b>with Microsoft</b>',
          ES: 'Regístrate <b>con Microsoft</b>',
          PT: 'Cadastrar-se <b>com a Microsoft</b>',
          FR: 'S\'inscrire <b>avec Microsoft</b>'
        }
      }
    }
  },
  beforeMount () {
    if (this.lang !== 'EN' && this.lang !== 'ES' && this.lang !== 'PT' && this.lang !== 'FR') {
      this.lang = 'EN'
    }
  },
  methods: {
    loginWithGoogle () {
      const backendUrl = process.env.VUE_APP_BACKEND_URL || '/api'
      window.location.href = `${backendUrl}/glogin/validate`
    }
  }
}
</script>
<style lang="scss" scoped>
  @use "../../assets/styles/variables.scss" as *;
</style>
